module.exports = __webpack_public_path__ + "static/media/SWSCRC1-26.1f13472c.mp3";